
export default function AppLogo() {
  return (
    <div
      className="flex flex-col justify-end leading-tight text-white"
    >
      <p className="text-xl font-semibold tracking-wide md:text-2xl">The HUB</p>
      <p className="text-xs font-medium uppercase tracking-[0.18em] text-white/85 md:text-sm">By DWF</p>
    </div>
  );
}
